import React from 'react'
import Box from "@mui/material/Box";

import {ListDealsPageHeader} from "./ListDealsPageHeader";
import {ListDealsList} from "./ListDealsList";

import './ListDealsPage.scss'
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

export const ListDealsPage = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    return (
        <React.Fragment>
            <Box
                id={"ListDealsPage"}
                className={"ListDealsPage"}
                style={{
                    padding: isTabletOrMobile ? '20px' : '20px 80px',
                    minHeight: '100vh',
                    background: '#0f1117',
                    color: '#fff',
                    overflow: 'auto',
                }}
            >
                <ListDealsPageHeader/>
                <ListDealsList />
            </Box>
        </React.Fragment>
    )
}
